import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

/* Layout */
import Layout from "@/layout";

/* Router Modules */
import componentsRouter from "./modules/components";
import chartsRouter from "./modules/charts";

// import nestedRouter from './modules/nested'
import coreRouter from "./modules/core";
import tableRouter from "./modules/table";
import generatorRouter from "./modules/generator";
import vpSwDebugRouter from "./modules/vp-sw";

export const constantRoutes = [
  // {
  //   path: '/redirect',
  //   component: Layout,
  //   hidden: true,
  //   children: [
  //     {
  //       path: '/redirect/:path(.*)',
  //       component: () => import('@/views/redirect/index')
  //     }
  //   ]
  // },
  // {
  //   path: '/login',
  //   component: () => import('@/views/login/index'),
  //   hidden: true
  // },
  // {
  //   path: '/auth-redirect',
  //   component: () => import('@/views/login/auth-redirect'),
  //   hidden: true
  // },
  // {
  //   path: '/404',
  //   component: () => import('@/views/error-page/404'),
  //   hidden: true
  // },
  // {
  //   path: '/401',
  //   component: () => import('@/views/error-page/401'),
  //   hidden: true
  // },
  // {
  //   path: '/applicationEditor',
  //   component: () => import('@/views/error-page/applicationEditor'),
  //   hidden: true
  // },
  // {
  //   path: '/',
  //   component: Layout,
  //   redirect: '/dashboard',
  //   children: [
  //     {
  //       path: 'dashboard',
  //       component: () => import('@/views/dashboard/index'),
  //       name: 'Dashboard',
  //       meta: { title: 'dashboard', icon: 'dashboard',  }
  //     },
  //   ]
  // },
  // {
  //   path: '/system',
  //   component: Layout,
  //   redirect: '/system/user',
  //   meta: { title: 'system.name', icon: 'dashboard',  },
  //   children: [
  //     {
  //       path: 'user',
  //       component: () => import('@/views/system/user/index'),
  //       name: 'user',
  //       meta: { title: 'system.user', icon: 'dashboard',  }
  //     },
  //     {
  //       path: 'role',
  //       component: () => import('@/views/system/role/index'),
  //       name: 'role',
  //       meta: { title: 'system.role', icon: 'dashboard',  }
  //     },
  //     {
  //       path: 'dept',
  //       component: () => import('@/views/system/dept/index'),
  //       name: 'dept',
  //       meta: { title: 'system.dept', icon: 'dashboard',  }
  //     },
  //     {
  //       path: 'menu',
  //       component: () => import('@/views/system/menu/index'),
  //       name: 'menu',
  //       meta: { title: 'system.menu', icon: 'dashboard',  }
  //     }
  //   ]
  // },
  // {
  //   path: '/documentation',
  //   component: Layout,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/documentation/index'),
  //       name: 'Documentation',
  //       meta: { title: 'documentation', icon: 'documentation',  }
  //     }
  //   ]
  // },
  // {
  //   path: '/guide',
  //   component: Layout,
  //   redirect: '/guide/index',
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/guide/index'),
  //       name: 'Guide',
  //       meta: { title: 'guide', icon: 'guide', noCache: true }
  //     }
  //   ]
  // },
  // {
  //   path: '/profile',
  //   component: Layout,
  //   redirect: '/profile/index',
  //   hidden: true,
  //   children: [
  //     {
  //       path: 'index',
  //       component: () => import('@/views/profile/index'),
  //       name: 'Profile',
  //       meta: { title: 'profile', icon: 'user', noCache: true }
  //     }
  //   ]
  // },
  // { path: '*', redirect: '/404', hidden: true }
];

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */

export const asyncRoutes = [
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    children: [
      {
        path: "/dashboard",
        component: () => import("@/views/dashboard/index"),
        name: "Dashboard",
        meta: { title: "Dashboard", icon: "dashboard", keepAlive: true },
        // meta: { title: 'Dashboard', icon: 'dashboard' , keepAlive: false}
      },
      {
        path: "/terminal",
        component: () => import("@/views/terminal/index"),
        name: "Terminal",
        meta: { title: "Terminal", icon: "dashboard" },
        // meta: { title: 'Dashboard', icon: 'dashboard' , keepAlive: false}
      },
      // {
      //   path: 'hxopt',
      //   component: () => import('@/views/vnc/index'),
      //   name: 'hxopt',
      //   meta: { title: 'hxopt', icon: 'dashboard',  }
      // },
    ],
  },
  {
    path: "/RTL",
    component: Layout,
    redirect: "/RTL/Composer",
    meta: {
      title: "Table",
      icon: "table",
    },
    children: [
      {
        path: "Composer",
        component: () => import("@/views/RTL/index"),
        name: "RTLComposer",
        meta: { title: "RTL Composer", icon: "dashboard", keepAlive: true },
        // meta: { title: 'ip-UVM' , }
      },
      {
        path: "edit",
        component: () => import("@/views/edit/index"),
        name: "RTLEditor",
        meta: { title: "RTL Editor", icon: "dashboard", keepAlive: true },
        // meta: { title: 'ip-UVM' , }
      },
      {
        path: "editai",
        component: () => import("@/views/edit/indexai"),
        name: "RTLEditorAi",
        meta: { title: "RTL Editor AI", icon: "dashboard", keepAlive: true },
        // meta: { title: 'ip-UVM' , }
      },
    ],
  },
  {
    path: "/profile",
    component: Layout,
    redirect: "/profile/index",
    hidden: true,
    children: [
      {
        path: "index",
        component: () => import("@/views/profile/index"),
        name: "Profile",
        meta: { title: "profile", icon: "user", noCache: true },
      },
    ],
  },
  // {
  //   path: "/login",
  //   component: () => import("@/views/login/index"),
  //   hidden: true,
  // },
  {
    path: "/login",
    component: () => import("@/views/login/cloudLogin"),
    hidden: true,
  },
  // {
  //   path: "/register",
  //   component: () => import("@/views/register/index"),
  //   hidden: true,
  // },
  {
    path: "/register",
    component: () => import("@/views/register/cloudRegister"),
    hidden: true,
  },
  {
    path: "/resetPassword",
    component: () => import("@/views/register/forgetPassword"),
    hidden: true,
  },
  /** when your routing map is too long, you can split it into small modules **/
  // nestedRouter,
  coreRouter,
  chartsRouter,
  // componentsRouter,
  tableRouter,
  {
    path: "/system",
    component: Layout,
    redirect: "/system/user",
    meta: { title: "system.name", icon: "dashboard" },
    children: [
      {
        path: "user",
        component: () => import("@/views/system/user/index"),
        name: "user",
        meta: { title: "system.user", icon: "dashboard" },
      },
      {
        path: "role",
        component: () => import("@/views/system/role/index"),
        name: "role",
        meta: { title: "system.role", icon: "dashboard" },
      },
      {
        path: "dept",
        component: () => import("@/views/system/dept/index"),
        name: "dept",
        meta: { title: "system.dept", icon: "dashboard" },
      },
      {
        path: "menu",
        component: () => import("@/views/system/menu/index"),
        name: "menu",
        meta: { title: "system.menu", icon: "dashboard" },
      },
      {
        path: "dict",
        component: () => import("@/views/system/dict/index"),
        name: "dict",
        meta: { title: "system.dict", icon: "dashboard" },
      },
      {
        path: "dict-data/index/:dictId(\\d+)",
        component: () => import("@/views/system/dict/data"),
        name: "Data",
        meta: { title: "字典数据", activeMenu: "/system/dict" },
      },
      {
        path: "server",
        component: () => import("@/views/system/server/index"),
        name: "server",
        meta: { title: "server", icon: "dashboard" },
      },
      {
        path: "log/logininfo",
        component: () => import("@/views/system/log/logininfo/index"),
        name: "logininfo",
        meta: { title: "logininfo", icon: "dashboard" },
      },
    ],
  },
  {
    path: "/example",
    component: Layout,
    redirect: "/example/list",
    name: "Example",
    meta: {
      title: "example",
      icon: "el-icon-s-help",
    },
    children: [
      {
        path: "base",
        component: () => import("@/views/example/base"),
        name: "BaseArticle",
        meta: { title: "Git Setting" },
      },
      {
        path: "mcp",
        component: () => import("@/views/example/mcp"),
        name: "MCPSetting",
        meta: { title: "MCP Setting" },
      },
      {
        path: "create",
        component: () => import("@/views/example/create"),
        name: "CreateArticle",
        meta: { title: "Regression Configuration" },
      },
      {
        path: "list",
        component: () => import("@/views/example/list"),
        name: "ArticleList",
        meta: { title: "Regression Statistic" },
      },
      {
        path: "edit",
        component: () => import("@/views/example/edit/edit"),
        name: "edit",
        meta: { title: "Waveform Debug" },
      },
      {
        path: "wavedrom",
        component: () => import("@/views/example/Wavedrom"),
        name: "wavedrom",
        meta: { title: "wavedrom" },
      },
      {
        path: "bug",
        component: () => import("@/views/example/bug/list"),
        name: "defectManagement",
        meta: { title: "Defect Management", keepAlive: true },
      },
      // {
      //   path: "detail",
      //   component: () => import("@/views/example/bug/detail"),
      //   name: "Defect Management Detail",
      //   meta: { title: "Defect Management Detail" },
      //   hidden: true,
      // },
      {
        path: "caseList/:id",
        component: () => import("@/views/example/caseList"),
        name: "caseList",
        beforeEnter: (to, from, next) => {
          to.meta.title = "Test Results Check";
          next();
        },

        //meta: { title: 'caseList'}
      },
      {
        path: "statistics",
        component: () => import("@/views/example/statistics"),
        name: "statistics",
        meta: { title: "Statistics" },
        hidden: true,
      },
      {
        path: "coverage",
        component: () => import("@/views/example/coverage"),
        name: "coverage",
        meta: { title: "coverage" },
        hidden: true,
      },
      {
        path: "fixStatus",
        component: () => import("@/views/example/fixStatus"),
        name: "fixStatus",
        meta: { title: "fixStatus" },
        hidden: true,
      },
    ],
  },
  {
    path: "/task",
    component: Layout,
    redirect: "/task/index",
    meta: {
      title: "task",
      icon: "el-icon-s-help",
    },
    children: [
      {
        path: "/task/index",
        component: () => import("@/views/task/index"),
        name: "Task",
        meta: { title: "Task", icon: "education", keepAlive: true },
      },
    ],
  },
  {
    path: "/error",
    component: Layout,
    redirect: "noRedirect",
    name: "ErrorPages",
    meta: {
      title: "errorPages",
      icon: "excel",
    },
    children: [
      {
        path: "401",
        component: () => import("@/views/error-page/401"),
        name: "Page401",
        meta: { title: "page401", noCache: true },
      },
      {
        path: "404",
        component: () => import("@/views/error-page/404"),
        name: "Page404",
        meta: { title: "page404", noCache: true },
      },
    ],
  },

  generatorRouter,
  vpSwDebugRouter,
  coreRouter,

  // tableRouter
  componentsRouter,
  {
    path: "/until",
    component: Layout,
    redirect: "hxopt",
    meta: { title: "3rd Party Tools", icon: "dashboard" },
    children: [
      {
        path: "hxopt",
        component: () => import("@/views/vnc/index"),
        name: "hxopt",
        meta: { title: "hxopt", icon: "dashboard" },
      },
      {
        path: "vivado",
        component: () => import("@/views/vnc/vivado"),
        name: "vivado",
        meta: { title: "VIVADO", icon: "dashboard" },
      },
      {
        path: "FusionDebug",
        component: () => import("@/views/vnc/FusionDebug"),
        name: "FusionDebug",
        meta: { title: "FusionDebug", icon: "dashboard" },
      },
      {
        path: "claryti",
        component: () => import("@/views/vnc/claryti"),
        name: "claryti",
        meta: { title: "CLARYTI", icon: "dashboard" },
      },
      {
        path: "hxopt2",
        component: () => import("@/views/vnc/index2"),
        name: "hxopt2",
        meta: { title: "App Store", icon: "dashboard" },
      },
    ],
  },
  // 404 page must be placed at the end !!!
  { path: "*", redirect: "/404", hidden: true },
];
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: asyncRoutes,
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  console.log(newRouter);
  router.matcher = newRouter.matcher; // reset router
}

export default router;

export const dynamicRoutes = [
  // {
  //   path: '/system/user-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:user:edit'],
  //   children: [
  //     {
  //       path: 'role/:userId(\\d+)',
  //       component: () => import('@/views/system/user/authRole'),
  //       name: 'AuthRole',
  //       meta: { title: '分配角色', activeMenu: '/system/user' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/role-auth',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:role:edit'],
  //   children: [
  //     {
  //       path: 'user/:roleId(\\d+)',
  //       component: () => import('@/views/system/role/authUser'),
  //       name: 'AuthUser',
  //       meta: { title: '分配用户', activeMenu: '/system/role' }
  //     }
  //   ]
  // },
  // {
  //   path: '/system/dict-data',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['system:dict:list'],
  //   children: [
  //     {
  //       path: 'index/:dictId(\\d+)',
  //       component: () => import('@/views/system/dict/data'),
  //       name: 'Data',
  //       meta: { title: '字典数据', activeMenu: '/system/dict' }
  //     }
  //   ]
  // },
  // {
  //   path: '/monitor/job-log',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['monitor:job:list'],
  //   children: [
  //     {
  //       path: 'index/:jobId(\\d+)',
  //       component: () => import('@/views/monitor/job/log'),
  //       name: 'JobLog',
  //       meta: { title: '调度日志', activeMenu: '/monitor/job' }
  //     }
  //   ]
  // },
  // {
  //   path: '/tool/gen-edit',
  //   component: Layout,
  //   hidden: true,
  //   permissions: ['tool:gen:edit'],
  //   children: [
  //     {
  //       path: 'index/:tableId(\\d+)',
  //       component: () => import('@/views/tool/gen/editTable'),
  //       name: 'GenEdit',
  //       meta: { title: '修改生成配置', activeMenu: '/tool/gen' }
  //     }
  //   ]
  // }
];
